<div class="padding-wrapper">
  <div class="wrapper portfolio-page">
    <div class="page-header">
      <div>
        <p class="section-kicker">Mes organisations</p>
        <h1>Toutes mes organisations</h1>
        <p class="page-intro">
          Retrouvez en un seul endroit les offres, parcours et points d'attention de toutes vos organisations.
        </p>
      </div>
    </div>

    <div class="loading-state" *ngIf="loading">
      <app-spinner></app-spinner>
      <p>Consolidation du portefeuille en cours…</p>
    </div>

    <ng-container *ngIf="!loading">
      <div class="summary-grid">
        <div class="summary-card">
          <p class="section-kicker">Organisations</p>
          <p class="summary-value">{{ organizationsCount }}</p>
          <p class="summary-note">organisations que vous accompagnez</p>
        </div>
        <div class="summary-card attention">
          <p class="section-kicker">Actions prioritaires</p>
          <p class="summary-value">{{ attentionCount }}</p>
          <p class="summary-note">à votre attention</p>
        </div>
        <div class="summary-card">
          <p class="section-kicker">Collaborateurs</p>
          <p class="summary-value">{{ totalMembers }}</p>
          <p class="summary-note">invités au total</p>
        </div>
        <div class="summary-card">
          <p class="section-kicker">Crédits disponibles</p>
          <p class="summary-value">{{ totalCredits }}</p>
          <p class="summary-note">parcours disponibles au total</p>
        </div>
      </div>

      <div class="alerts-panel" *ngIf="topAlerts.length">
        <div class="panel-header">
          <div>
            <p class="section-kicker">Priorités</p>
            <h2>Ce qui mérite votre attention</h2>
          </div>
          <div class="panel-meta">{{ pendingPaymentCount }} paiement{{ pendingPaymentCount > 1 ? 's' : '' }} en attente</div>
        </div>

        <div class="alerts-list">
          <div class="alert-item" *ngFor="let alertItem of topAlerts" [ngClass]="'tone-' + alertItem.alert.tone">
            <div>
              <strong>{{ alertItem.organizationName }}</strong>
              <p>{{ alertItem.alert.label }}</p>
            </div>
            <span class="alert-chip">{{ getAlertToneLabel(alertItem.alert.tone) }}</span>
          </div>
        </div>
      </div>

      <div class="filters-panel">
        <div class="filters-row">
          <app-input
            class="search-input"
            [margin-bottom]="false"
            type="search"
            placeholder="Rechercher une organisation"
            [inputField]="searchForm"
          ></app-input>
          <div class="filter-chips">
            <button type="button" class="filter-chip" [class.active]="selectedFilter === 'all'" (click)="setFilter('all')">
              Toutes
            </button>
            <button type="button" class="filter-chip" [class.active]="selectedFilter === 'attention'" (click)="setFilter('attention')">
              À traiter
            </button>
            <button type="button" class="filter-chip" [class.active]="selectedFilter === 'payments'" (click)="setFilter('payments')">
              Paiements en attente
            </button>
            <button type="button" class="filter-chip" [class.active]="selectedFilter === 'renewals'" (click)="setFilter('renewals')">
              Renouvellements proches
            </button>
            <button type="button" class="filter-chip" [class.active]="selectedFilter === 'no-offer'" (click)="setFilter('no-offer')">
              Sans offre
            </button>
          </div>
        </div>
      </div>

      <div class="empty-state panel" *ngIf="!filteredItems.length">
        <p class="section-kicker">Aucun résultat</p>
        <h2>Aucune organisation ne correspond à ce filtre</h2>
        <p>Ajustez la recherche ou revenez sur l’ensemble du portefeuille.</p>
      </div>

      <div class="portfolio-list" *ngIf="filteredItems.length">
        <section class="portfolio-card panel" *ngFor="let item of filteredItems" [ngClass]="'tone-' + getItemTone(item)">
          <div class="panel-header panel-header--top">
            <div>
              <p class="section-kicker">{{ item.parentLabel ? item.parentLabel : 'Organisation' }}</p>
              <div class="portfolio-title-row">
                <h2>{{ item.organization.name }}</h2>
                <div class="offer-highlight" [ngClass]="item.hasActiveOffer ? 'offer-highlight--active' : 'offer-highlight--missing'">
                  <span class="offer-highlight__label">{{ item.hasActiveOffer ? 'Offre active' : 'Statut offre' }}</span>
                  <strong class="offer-highlight__value">{{ item.planLabel }}</strong>
                </div>
              </div>
              <div class="portfolio-meta-row">
                <p class="portfolio-subtitle">
                  {{ item.resume.activatedMembers }}/{{ item.resume.members }} collaborateurs inscrits
                </p>
              </div>
            </div>
            <div class="panel-actions panel-actions--top">
              <app-button type="button" [outline]="true" (onClick)="goToUnits(item)">Voir l'offre</app-button>
              <app-button type="button" [primary]="true" (onClick)="goToOrganization(item)">Gérer ce compte</app-button>
            </div>
          </div>
          <div class="portfolio-stats-strip">
            <div class="portfolio-stat portfolio-stat--credits">
              <span class="portfolio-stat__dot"></span>
              <strong>{{ item.displayedUnits }}</strong>
              <span>crédits disponibles</span>
            </div>
            <div class="portfolio-stat portfolio-stat--journeys">
              <span class="portfolio-stat__dot"></span>
              <strong>{{ item.journeysRemaining }}</strong>
              <span>parcours restants</span>
            </div>
            <div class="portfolio-stat portfolio-stat--seats">
              <span class="portfolio-stat__dot"></span>
              <strong>Nombre de collaborateurs : {{ item.seatCount ? item.seatCount : 'à définir' }}</strong>
            </div>
            <div class="portfolio-stat portfolio-stat--renewal">
              <span class="portfolio-stat__dot"></span>
              <strong>Renouvellement : {{ item.nextRenewalAt ? formatDate(item.nextRenewalAt) : 'pas encore programmé' }}</strong>
            </div>
            <div class="portfolio-stat portfolio-stat--members">
              <span class="portfolio-stat__dot"></span>
              <strong>{{ item.resume.members }}</strong>
              <span>collaborateurs invités</span>
            </div>
            <div class="portfolio-stat portfolio-stat--activated">
              <span class="portfolio-stat__dot"></span>
              <strong>{{ item.resume.activatedMembers }}</strong>
              <span>collaborateurs inscrits</span>
            </div>
            <div class="portfolio-stat portfolio-stat--talkers">
              <span class="portfolio-stat__dot"></span>
              <strong>{{ item.resume.talkers }}</strong>
              <span>talkers actifs</span>
            </div>
            <div class="portfolio-stat portfolio-stat--payment" *ngIf="item.pendingPaymentRecord">
              <span class="portfolio-stat__dot"></span>
              <strong>{{ formatCurrency(item.pendingPaymentRecord.amountCents) }}</strong>
              <span>paiement en attente</span>
            </div>
          </div>

          <div class="alerts-inline" *ngIf="item.alerts.length; else healthyState">
            <div class="inline-chip" *ngFor="let alert of item.alerts" [ngClass]="'tone-' + alert.tone">
              {{ alert.label }}
            </div>
          </div>

          <ng-template #healthyState>
            <div class="alerts-inline">
              <div class="inline-chip tone-info">Rien à signaler</div>
            </div>
          </ng-template>
        </section>
      </div>
    </ng-container>
  </div>
</div>
